import React from 'react'
import { useTranslation } from 'react-i18next'
import FlexRow from 'components/Layout/FlexRow'
import './VoohImpressionsFilters.scss'
import { SelectOption } from '../../../../../../components/Form/Select'
import SelectMultiCheckbox from '../../../../../../components/Form/SelectMultiCheckbox'
import { useDispatch, useSelector } from 'react-redux'
import { VoohImpressionsFilterItem } from '../../types'
import { voohCampaignRealizationActions } from '../../slice'
import { RootState } from '../../../../../../store'

const VoohImpressionsFilters: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const filters = useSelector((state: RootState) => state.vooCampaignRealization).filters
  const loading = useSelector((state: RootState) => state.vooCampaignRealization).loading

  const valueToSelectOption = (filterItem: VoohImpressionsFilterItem): SelectOption => ({
    value: filterItem.value,
    label: filterItem.key,
  })

  return (
    <FlexRow className='CampaignDetailsChartFilters'>
      <div className={'CampaignDetailsChartFilters__row'}>
        <SelectMultiCheckbox
          id='networks'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                network: filters.network.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.network]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.network')}
          value={filters.network.filter(el => el.selected).map(el => el.value)}
        />

        <SelectMultiCheckbox
          id='brand'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                brands: filters.brands.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.brands]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.brand')}
          value={filters.brands.filter(el => el.selected).map(el => el.value)}
        />

        <SelectMultiCheckbox
          id='agglomerations'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                agglomerations: filters.agglomerations.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.agglomerations]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.agglomeration')}
          value={filters.agglomerations.filter(el => el.selected).map(el => el.value)}
        />

        <SelectMultiCheckbox
          id='city'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                cities: filters.cities.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.cities]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.city')}
          value={filters.cities.filter(el => el.selected).map(el => el.value)}
        />

        <SelectMultiCheckbox
          id='medium'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                media: filters.media.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.media]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.medium')}
          value={filters.media.filter(el => el.selected).map(el => el.value)}
        />

        <SelectMultiCheckbox
          id='creation'
          className='FilterSelect'
          disabled={loading}
          closeOnSelect={false}
          onChange={(selected: string[]): void => {
            void dispatch(
              voohCampaignRealizationActions.setFilters({
                ...filters,
                creations: filters.creations.map(filter => {
                  if (selected.find(selected => selected === filter.value)) {
                    return { ...filter, selected: true }
                  }

                  return { ...filter, selected: false }
                }),
              })
            )
            void dispatch(voohCampaignRealizationActions.setFetchedChartData(false))
          }}
          options={[...filters.creations]
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(valueToSelectOption)}
          selectAllOption
          title={t('common.creation')}
          value={filters.creations.filter(el => el.selected).map(el => el.value)}
        />
      </div>
    </FlexRow>
  )
}

export default VoohImpressionsFilters
